module.exports = ".img-center {\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.image-cursor {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/schedule/milestone/milestone.component.css
// module id = ./src/app/modules/dashboard/schedule/milestone/milestone.component.css
// module chunks = dashboard.module